<template>
  <div class="search-result-wrapper" v-loading="loading">
    <!-- nav bar -->
    <el-menu class="search-menu" :default-active="activeMenu" mode="horizontal" @select="handleMenuSelect">
      <el-menu-item v-for="item in menu" :key="item.menuId" :index="item.menuId">{{ item.label }}</el-menu-item>
    </el-menu>
    <!-- result -->
    <div class="search-contents">
      <el-scrollbar :ref="scrollbarRef">
        <div style="width:100%;">
          <div class="main">
            <w-related-info v-if="relatedInfo !== null" :data="relatedInfo" @search-related-obj="searchRelatedObj" />
            <w-search-result-detail :data="menuFilterdResult" :is-total-view="isTotalView" :search-keyword="keyword" @menu-change="handleMenuSelect" @open-log-popup="openLogPopup" />
          </div>
          <div class="side">
            <w-search-target-obj-info v-if="searchTargetData !== null" :data="searchTargetData" />
          </div>
        </div>
        <w-scroll-top-button :visible="enableScollTop" @move-scroll-top="moveScrollTop"></w-scroll-top-button>
      </el-scrollbar>
    </div>
    <w-search-log-popup ref="logPopup" />
  </div>
</template>

<script>
import { filter, cloneDeep, map, concat, isNil } from 'lodash';
import MsgUtil from '@/utils/message';
import { defaultPagination } from '@/constants/table';
import SearchAPI from '@/api/frame/smart-search';
import scrollbarMixins from '@/mixins/scrollbar';
import WRelatedInfo from './RelatedInfo';
import WSearchResultDetail from './SearchResultDetail';
import WSearchTargetObjInfo from './SearchTargetObjInfo';
import WSearchLogPopup from './popup/SearchLogPopup';

const totalMenu = {
  label: '전체',
  menuId: 'TOTAL',
};
const DEFAULT_PAGE_SIZE = defaultPagination.pageSize;
export default {
  name: 'WSearchResultView',
  components: {
    WRelatedInfo,
    WSearchResultDetail,
    WSearchTargetObjInfo,
    WSearchLogPopup,
  },
  mixins: [scrollbarMixins],
  props: {
    keyword: {
      type: String,
    },
  },
  data() {
    return {
      /**
       * 검색어
       * @type {[type]}
       */
      searchKeyword: this.keyword,
      /**
       * 활성화된 메뉴
       * @type {String}
       */
      activeMenu: 'TOTAL',
      /**
       * 기본 메뉴
       * @type {Object}
       */
      totalMenu,
      /**
       * 메뉴 TAB
       * @type {Array}
       */
      menu: [totalMenu],
      /**
       * 검색 결과
       * @type {Object}
       */
      searchResult: [],
      /**
       * 단일장비 상세 검색 정보
       * @type {[type]}
       */
      searchTargetData: null,
      /**
       * 연관 정보
       * @type {Array}
       */
      relatedInfo: [],
      /**
       * 로드마스크
       * @type {Boolean}
       */
      loading: false,
    };
  },
  computed: {
    managerId() {
      return this.$store.getters.userInfo.managerId;
    },
    /**
     * 페이징 툴바 표시를 위한 전체 탭 여부
     * @author Hunui
     * @return {Boolean} [description]
     */
    isTotalView() {
      return this.activeMenu === 'TOTAL';
    },
    /**
     * 활성화된 탭에 따라 필터링된 데이터를 반환
     * @author Hunui
     * @return {[type]} 필터 데이터
     */
    menuFilterdResult() {
      const searchArr = cloneDeep(this.searchResult);
      if (this.isTotalView) {
        return searchArr;
      }
      return filter(searchArr, (type) => type.menuId === this.activeMenu);
    },
  },
  mounted() {
    this.loadData();
    this.setScrollData();
  },
  methods: {
    /**
     * 결과 화면에서 검색 길행
     * @author Hunui
     * @param  {[type]} searchKeyword [description]
     * @return {[type]}               [description]
     */
    searchAction(searchKeyword) {
      this.searchKeyword = searchKeyword;
      this.loadData();
    },
    /**
     * 연관장비로 검색 실행
     * @author Hunui
     * @param  {[type]} searchKeyword [description]
     * @return {[type]}               [description]
     */
    searchRelatedObj(searchKeyword) {
      this.$emit('search-related-obj', searchKeyword);
    },
    /**
     * 메뉴 변경 또는 더보기 클릭시 스크롤바 최상단으로 이동
     * @author Hunui
     * @param  {[type]} menu [description]
     * @return {[type]}      [description]
     */
    handleMenuSelect(menu) {
      if (this.activeMenu === menu) {
        return;
      }
      this.activeMenu = menu;
      this.$nextTick(() => {
        this.moveScrollTop();
      });
    },
    //  검색
    loadData() {
      const params = {
        menuId: this.activeMenu,
        managerId: this.managerId,
        searchKeyword: this.searchKeyword,
        checkDatetime: new Date(),
      };

      let action = MsgUtil.action.VIEW;
      let target = '검색 결과';
      this.loading = true;
      SearchAPI.getSearchResult(this.searchKeyword, DEFAULT_PAGE_SIZE)
        .then((response) => {
          if (response.data.success) {
            this.activeMenu = 'TOTAL';

            const data = response.data.data;
            const result = data.result;
            this.searchResult = result;

            // 메뉴 데이터
            const menu = map(result, (o) => ({
              label: o.menuName,
              menuId: o.menuId,
            }));
            this.menu = concat([this.totalMenu], menu);
            this.relatedInfo = isNil(data.relatedObj) ? null : data.relatedObj;
            this.searchTargetData = isNil(data.obj) ? null : data.obj;

            this.$nextTick(() => {
              this.moveScrollTop();
            });
          } else {
            this.$message(MsgUtil.getResultMsgData(action, target, false));
          }
        })
        .catch((e) => {
          this.$message(MsgUtil.getResultMsgData(action, target, false));
          throw new Error(e);
        })
        .finally(() => {
          this.loading = false;
        });
      action = MsgUtil.action.ADD;
      target = '최근 검색 기록';
      SearchAPI.addSearchHist(params)
        .then((response) => {
          if (response.data.success) {
            // this.$message(MsgUtil.getResultMsgData(action, target, true));
          } else {
            this.$message(MsgUtil.getResultMsgData(action, target, false));
          }
        })
        .catch((e) => {
          this.$message(MsgUtil.getResultMsgData(action, target, false));
          throw new Error(e);
        });
    },
    /**
     * 장비 12시간 로그정보 팝업 오픈
     * @author Hunui
     * @param  {[type]} obj [description]
     * @return {[type]}     [description]
     */
    openLogPopup(obj) {
      this.$refs.logPopup.open();
      this.$nextTick(() => {
        this.$refs.logPopup.initData(obj);
      });
    },
    /**
     * 데이터 초기화
     * @author Hunui
     */
    reset() {
      this.loading = false;
      this.activeMenu = 'TOTAL';

      this.searchResult = [];
      this.searchTargetData = null;
      this.relatedInfo = [];
      this.menu = [this.totalMenu];
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/frame/components/popup/SmartSearchPopup/SearchResultView/index.vue